export default __webpack_public_path__ + "static/media/IMG-20241005-WA0058.da10e18b.jpg";